import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';

function delegate(action, reqGranted, args, tp) {
  if (reqGranted) {
    action(...args);
  }
}

function getCookieConsentResponse() {
  const iub_ls = localStorage.getItem('loq-chl:cookieConsent') === 'true';
  const cookiePolId = parseInt(process.env.REACT_APP_COOKIE_POLICY_ID);
  const cookieConsentResponse = _getCookieConsentResponse();
  const reqGranted = (cookieConsentResponse.id === cookiePolId && cookieConsentResponse.consent === true) ?? iub_ls;

  function _getCookieConsentResponse() {
    const iub_cook = window.document.cookie.split(';').find((v) => v.startsWith(' _iub_cs-' + cookiePolId)) ?? null;

    return JSON.parse(decodeURIComponent(iub_cook === null ? '{}' : iub_cook.split('=')[1]));
  }

  return reqGranted;
}

function _FacebookPixel() {
  let reqGranted = getCookieConsentResponse();
  let _id;
  let _options;

  window.document.body.addEventListener('cookieConsentUpdate', () => {
    reqGranted = getCookieConsentResponse();
    init();
  });

  function updatePermission() {
    if (reqGranted) {
      ReactPixel.grantConsent();
    } else {
      ReactPixel.revokeConsent();
    }
  }

  function init(fbpId, options) {
    _id = _id ?? fbpId;
    _options = _options ?? options;
    ReactPixel.init(_id, _options);
    updatePermission();
  }

  function pageView() {
    delegate(ReactPixel.pageView, reqGranted, [], 'fbp');
  }

  function track(title, data) {
    delegate(ReactPixel.track, reqGranted, [title, data], 'fbp');
  }

  return { init, track, pageView };
}

function _GA() {
  let reqGranted = getCookieConsentResponse();
  let _id;
  let _debug;

  window.document.body.addEventListener('cookieConsentUpdate', () => {
    reqGranted = getCookieConsentResponse();
    init();
  });

  function init(id, debug) {
    _id = _id ?? id;
    _debug = _debug ?? debug;

    if (reqGranted) {
      ReactGA.initialize(_id, {
        debug: !!_debug,
      });
    }
  }

  function pageView() {
    delegate(ReactGA.pageview, reqGranted, [window.location.pathname + window.location.search], 'ga');
  }

  function event(arg) {
    delegate(ReactGA.event, reqGranted, [arg], 'ga');
  }

  return { init, event, pageView };
}

export const FacebookPixel = _FacebookPixel();
export const GA = _GA();
